import React from 'react';

interface TextAreaProps {
    value: string;
    placeholder?: string;
    onChange: (value: string) => void;
    onSubmit?: () => void;
    disabled?: boolean;
    rows?: number;
    fullHeight?: boolean;
}

function TextArea({value, placeholder = '', onChange, onSubmit, disabled = false, rows = 3, fullHeight}: TextAreaProps): JSX.Element {
    return (
        <textarea
            className="c-sidepanel__input"
            data-cy="inputMessage"
            id="review-text"
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={(e) => onSubmit && e.ctrlKey && e.code === 'Enter' && onSubmit()}
            placeholder={placeholder}
            disabled={disabled}
            rows={rows}
            style={{height: fullHeight ? '100%' : undefined}}
            value={value}
        />
    );
}

export default TextArea;
